export default __webpack_public_path__ + "static/media/studentRealCase2-mobile.189e9cf8.png";